import { render, staticRenderFns } from "./TournamentCarousel.vue?vue&type=template&id=792f5a0e&scoped=true&"
import script from "./TournamentCarousel.vue?vue&type=script&lang=js&"
export * from "./TournamentCarousel.vue?vue&type=script&lang=js&"
import style0 from "./TournamentCarousel.vue?vue&type=style&index=0&id=792f5a0e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792f5a0e",
  null
  
)

component.options.__file = "TournamentCarousel.vue"
export default component.exports